<template>
  <div class="customer-create main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $t('pos.discrepancy_report') }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link v-if="userType=='super_admin'" slot="item-title" to="/super-admin/dashboard" >{{ $t('general.home') }}</router-link>
          <router-link v-else-if="userType=='supplier'" slot="item-title" to="/supplier/dashboard" >{{ $t('general.home') }}</router-link>
          <router-link v-else-if="userType=='anchor'" slot="item-title" to="/anchor/dashboard" >{{ $t('general.home') }}</router-link>
          <router-link v-else-if="userType=='funder'" slot="item-title" to="/funder/dashboard" >{{ $t('general.home') }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link v-if="userType=='super_admin'" slot="item-title" to="/super-admin/purchase-orders">{{ $tc('pos.po', 2) }}</router-link>
          <router-link v-else-if="userType=='supplier'" slot="item-title" to="/supplier/purchase-orders" >{{ $tc('pos.po', 2) }}</router-link>
          <router-link v-else-if="userType=='anchor'" slot="item-title" to="/anchor/purchase-orders" >{{ $tc('pos.po', 2) }}</router-link>
          <router-link v-else-if="userType=='funder'" slot="item-title" to="/funder/purchase-orders" >{{ $tc('pos.po', 2) }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="#">{{ $tc('pos.discrepancy_report') }}</router-link>
        </li>
      </ol>
      <div v-if="discrepency_report.length>0" class="page-actions row">
        <div class="col-xs-2 mr-4">
          <base-button
            size="large"
            icon="arrow-down"
            color="theme"
            @click="download_excel"
          >
            {{ $t('data_exports.download_excel') }}
          </base-button>
        </div>
      </div>

    </div>
    <SinglePORow :fetchData="fetchData" :tableDivId="tableDivId"/>
    <table-component
      ref="table"
      :show-filter="false"
      :data="discrepency_report"
      table-class="table"
    >
      <table-column
        :label="$t('pos.item.title')"
        sort-as="name"
        show="name"
      />
      <table-column
        :label="$t('pos.item.part_number')"
        sort-as="part_number"
        show="part_number"
      />
      <table-column
        :label="$t('pos.item.reason')"
      >
        <template slot-scope="row">
          <p v-if="row.reason==='price_difference'" v-html="$t('pos.item.price_difference', {actual_price: $utils.formatGraphMoney(row.actual_price, currency) , requested_price:$utils.formatGraphMoney(row.requested_price, currency)})"/>
          <p v-else-if="row.reason==='item_not_found'" v-html="$t('pos.item.item_not_found')"/>
        </template>
      </table-column>
    </table-component>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AstronautIcon from '../../components/icon/AstronautIcon'
import SinglePORow from './SinglePurchaseOrderRow'
export default {
  components: {
    AstronautIcon,
    SinglePORow
  },
  data () {
    return {
      isRequestOngoing: true,
      filtersApplied: false,
      userType: '',
      fetchData: [],
      discrepency_report: [],
      tableDivId: 'tableDivId',
      POStatus: null,
      currency: null,
      POUniqueHashCode: null,
      url: null
    }
  },
  computed: {
    ...mapGetters('documentType', [
      'POAttachments',
      'totalPOAttachments',
      'selectedPOAttachments'
    ]),
    ...mapGetters('currency', [
      'defaultCurrency',
      'currencies'
    ])
  },
  created () {
    if (localStorage.getItem('role') === 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') === 'anchor') {
      this.userType = 'anchor'
    } else if (localStorage.getItem('account_type') === 'supplier') {
      this.userType = 'supplier'
    } else if (localStorage.getItem('account_type') === 'funder') {
      this.userType = 'funder'
    }
    this.loadPO()
  },

  methods: {
    ...mapActions('po', [
      'fetchPO',
      'SinglePOArray'
    ]),
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('documentType', [
      'deletePOAttachment',
      'fetchPOAttachments',
      'selectAllPOAttachments',
      'setSelectAllPOState',
      'selectPOAttachment',
      'deleteMultiplePOAttachments'
    ]),
    async loadPO () {
      let response = await this.SinglePOArray(this.$route.params.id)
      if (response.data) {
        this.fetchData = response.data.purchaseOrder
        this.POStatus = response.data.purchaseOrder[0].status
        this.POUniqueHashCode = response.data.purchaseOrder[0].unique_hash
        this.discrepency_report = response.data.purchaseOrder[0].item_discrepancy
        this.currency = response.data.purchaseOrder[0].supplier.account.currency
      }
    },
    download_excel () {
      if (!this.POUniqueHashCode) {
        return false
      }
      window.open(`/data-exports/po-discrepancy-report/${this.POUniqueHashCode}`)
    }
  }
}
</script>
<style scoped>
#tableDivId{
  min-height: 0px;
}
</style>
